import Cookies from 'js-cookie';

class ApplicationDetail {
  private static _instance: ApplicationDetail = new ApplicationDetail();
  private static userDetail: any;
  private static hospitalDetail: any;

  constructor() {
    if (ApplicationDetail._instance) {
      throw new Error('Use ApplicationDetail.instance');
    }
    ApplicationDetail._instance = this;
  }

  static get instance(): ApplicationDetail {
    return ApplicationDetail._instance;
  }

  private setUserDetail(userDetail: any): void {
    ApplicationDetail.userDetail = userDetail;
  }

  setApplicationDetail(appDetail: any): any {
    this.setUserDetail(appDetail.userDetails);
  }

  getUserDetail(): any {
    return ApplicationDetail.userDetail;
  }

  getUserName(): string {
    return ApplicationDetail?.userDetail?.userName;
  }

  getAccessToken(): string {
    return Cookies.get('token') || '';
  }

  getProfileId(): number {
    if (ApplicationDetail?.userDetail) {
      return ApplicationDetail?.userDetail?.profileId;
    } else {
      const userDetails = JSON.parse(localStorage.getItem('userDetail') as any);
      return userDetails?.profileId;
    }
  }
  getUserRole(): any {
    const userDetails = JSON.parse(localStorage.getItem('userDetail') as any);
    const { userRoles } = userDetails;
    return userRoles;
  }
}

export default ApplicationDetail;
